import * as React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import { Helmet } from "react-helmet-async";
import { InputGroup } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { SearchHeart } from "react-bootstrap-icons";
import Table from "react-bootstrap/Table";
import receptionFloorPlan from "../img/reception-floor-plan.webp";
import sortBy from "lodash/sortBy";

import "../styles/reception.css";

const tables = sortBy(
  [
    ["Adi Seshu Kommera (1)", 59],
    ["Ajit Patel (2)", 17],
    ["Amarnath Yada (3)", 23],
    ["Amitava Chatterjee (3)", 48],
    ["Andy Meyers (1)", 40],
    ["Anjaneyulu Koneru (2)", 22],
    ["Anukul Dass (2)", 8],
    ["Arun Kankani (2)", 12],
    ["Aruna Gummadi (2)", 13],
    ["Asha Dhume (2)", 12],
    ["Atma Ram (2)", 49],
    ["Avinash Kalagarla (2)", 25],
    ["Bachcha Tiwari  (3)", 46],
    ["Badruddin Pitter (3)", 57],
    ["Bashist Sharma (6)", 60],
    ["Benjamin Liu (1)", 38],
    ["Bhaskar Chunduri (4)", 54],
    ["Bhaskar Gollapudi (2)", 16],
    ["Bhaskar Pabba (2)", 7],
    ["Bhaskar Rao (3)", 62],
    ["Bhaskar Yalamanchili (2)", 51],
    ["Bijay Dixit (3)", 16],
    ["Bushra Khan (2)", 13],
    ["Carlos Garcia (2)", 41],
    ["Chandra Kondapaneni (1)", 24],
    ["Chandra Anugu (4)", 60],
    ["Chandra Jonnalagadda (2)", 61],
    ["Chandra S Padidem (2)", 26],
    ["Chandu Madireddy (1)", 56],
    ["Chandu Sirigiri (4)", 61],
    ["Charlie Patel (3)", 12],
    ["Chary Tamirisa (2)", 22],
    ["Chelsea Tang (1)", 36],
    ["Christina Ou (1)", 38],
    ["Craig LeTulle (1)", 40],
    ["Damodar Jammili (3)", 29],
    ["Dayakar Puskoor (2)", 40],
    ["Dayakar Reddy Davlapur (3)", 56],
    ["Derek Weidlein (2)", 41],
    ["Devesh Pathak (4)", 55],
    ["Dinesh Shah (2)", 11],
    ["Dinkar Chheda (1)", 39],
    ["Divakar jandyam (2)", 10],
    ["Divyakant Parikh (2)", 10],
    ["Elliot Tuck (2)", 36],
    ["Falgun Shah (2)", 7],
    ["George Willy (1)", 39],
    ["Gitesh Desai (1)", 4],
    ["Gopal Kurapati (4)", 25],
    ["Gopi Khande (4)", 31],
    ["Gupta Darisi (1)", 15],
    ["Hari Immadi (4)", 64],
    ["Hari Kotrike (3)", 23],
    ["Harish Reddy Kommera (1)", 59],
    ["Hasu Patel (1)", 4],
    ["Hersh Kumar (3)", 4],
    ["Hitakshi Patel (2)", 21],
    ["Jagat Kamdar (2)", 3],
    ["Jay Dalwadi (2)", 4],
    ["Jay Malhotra (2)", 36],
    ["Jayesh Ojha (1)", 21],
    ["Jithender Reddy (2)", 15],
    ["JP Mudhireddy (2)", 56],
    ["Jugal Malani (2)", 3],
    ["Kaladhar Jilla (7)", 66],
    ["Kamala Raghavan (2)", 11],
    ["Kantu Patel (2)", 46],
    ["Karen Yang (1)", 38],
    ["Kartheek Epuri (4)", 34],
    ["Karun Sreerama (2)", 54],
    ["Karunakar Chowdavarapu (1)", 16],
    ["Karunakar Kuchakulla (2)", 59],
    ["Kashi Alishala (1)", 6],
    ["Kaushik Chatterjee (4)", 45],
    ["KC Mehta (2)", 3],
    ["Keerthana Kumar (1)", 38],
    ["Keith Patel (1)", 41],
    ["Kesava Chakka (2)", 41],
    ["Keshav Kumar (2)", 8],
    ["Kevin Ku & Serena Wang (2)", 38],
    ["Kiran Mocharla (4)", 53],
    ["Kishore Paidimarry (2)", 65],
    ["Kranthi Gunda (4)", 65],
    ["Krishna Bendapudi (3)", 9],
    ["Krishna Giri (1)", 22],
    ["Krishna Lattupally (2)", 44],
    ["Krishna Prasad (2)", 52],
    ["Krishna Reddy Revoori (1)", 40],
    ["Kusum Vyas (2)", 11],
    ["Lakshmanan Sudhagar (4)", 14],
    ["Lakshmi Kamboji (2)", 8],
    ["Lakshmi Kondapi (3)", 33],
    ["Lalit Jallan (2)", 55],
    ["Laxmi Medi (2)", 63],
    ["Lila Shah (2)", 46],
    ["Lutfi Hassan (1)", 39],
    ["Madhav Sadhu (4)", 16],
    ["Madhav Boorgu (5)", 28],
    ["Madhu Katakam (5)", 28],
    ["Madhu Sekharan (2)", 18],
    ["Madhukar Adi (2)", 63],
    ["Mahesh Ranga (2)", 17],
    ["Mahesh Gade (4)", 58],
    ["Mahesh Patel (2)", 21],
    ["Mahesh Wadhwa (2)", 17],
    ["Malla Mekala (2)", 44],
    ["Mallik Thatipelli (1)", 41],
    ["Mani Vaitheeswaran (2)", 14],
    ["Manish Seth (2)", 39],
    ["Manisha Gandhi (1)", 10],
    ["Manjesh Ramasudhakara (3)", 6],
    ["Manohar Medi (2)", 63],
    ["Meera Kapur (2)", 12],
    ["Meera Srikanth (2)", 14],
    ["Mehmood Daya (2)", 47],
    ["Mehul Parikh (2)", 35],
    ["Mehul Parikh (Sara) (1)", 4],
    ["Michael Shum (2)", 46],
    ["Michelle Li (1)", 36],
    ["Mohan Ballagere (2)", 54],
    ["Munir Ibrahim (1)", 39],
    ["Munira Dhodiya (2)", 47],
    ["Mychael Nguyen (1)", 46],
    ["Naga Cheekoti (4)", 49],
    ["Nagesh Allada (4)", 20],
    ["Nanda Vura (3)", 48],
    ["Narayana Reddy Gandra (3)", 42],
    ["Narendra Kunapareddy (2)", 58],
    ["Nasrullah Khan (2)", 39],
    ["Navin Surya (4)", 25],
    ["Navin Patel (1)", 10],
    ["Nikita Khambe (2)", 40],
    ["Niranjan Kumar (2)", 44],
    ["Nisha Mirani (2)", 11],
    ["Nitya Raju (1)", 36],
    ["Nizar Ali (2)", 47],
    ["Noor Ali (1)", 47],
    ["Padmasri Mutyala (2)", 51],
    ["Pandu Kadire (2)", 52],
    ["Pardhasaradhi Vemuri (4)", 29],
    ["Pavan Achuta (2)", 5],
    ["Pragnesh Bhat (1)", 43],
    ["Prakash Patel (1)", 12],
    ["Prakash Velaga (4)", 19],
    ["Prasad Kalva (4)", 6],
    ["Prasad Maragani (4)", 62],
    ["Prashant Peddi (4)", 13],
    ["Pratap Erabelli (2)", 64],
    ["Praveen Korivi (4)", 51],
    ["Purna Kurre (1)", 41],
    ["Raghu Hakeem (3)", 58],
    ["Raghu Kotha (4)", 23],
    ["Raj Bhalla (2)", 37],
    ["Raj Chappidi (1)", 13],
    ["Rajasekhar Yalamanchili (2)", 51],
    ["Rajender Singh (2)", 21],
    ["Rajesh Dikonda (2)", 48],
    ["Rajesh Gampa (3)", 66],
    ["Rajesh Sanchala (1)", 10],
    ["Rajiv Bhavsar (2)", 5],
    ["Raju Srirama (2)", 43],
    ["Raju Vanguri (2)", 15],
    ["Rakesh Gundala (4)", 67],
    ["Ram Cheruvu (2)", 30],
    ["Rama Pakala (6)", 30],
    ["Ramana Bommareddy (1)", 10],
    ["Ramana Pothugunta (3)", 52],
    ["Ramesh Akarapu (2)", 49],
    ["Ramesh Gunda (3)", 50],
    ["Ramesh C Patel (2)", 24],
    ["Ramesh Konduri (3)", 7],
    ["Ramesh Maddi (4)", 56],
    ["Ramesh Parikh (2)", 4],
    ["Rana Dasgupta (2)", 32],
    ["Rao Alsakani (2)", 9],
    ["Rao Perla (3)", 26],
    ["Ratan Erukulla (4)", 19],
    ["Rathna Kumar (1)", 15],
    ["Ravi Arora (3)", 9],
    ["Ravi Dara (1)", 42],
    ["Ravi Podagatlapalli (4)", 33],
    ["Ravi Tamerisa (2)", 22],
    ["Ravi Varre (2)", 57],
    ["Ravikanth Ponnapalli (4)", 20],
    ["Regina Crafter (1)", 40],
    ["Rishika Kadire (4)", 61],
    ["Sai Mahesh Khande (4)", 31],
    ["Sam Merchant (1)", 39],
    ["Samba Reddy (2)", 42],
    ["Sanjay Ramabhadran (1)", 39],
    ["Sanjeev Reddy (3)", 59],
    ["Sanober Ali (2)", 47],
    ["Santosh Deme (4)", 32],
    ["Sarada Akunuri (2)", 6],
    ["Sathya Ramineni (2)", 31],
    ["Satish Nannapaneni (1)", 57],
    ["Satya Narendrula (2)", 5],
    ["Seenappa Poola (1)", 13],
    ["Seshadri Kumar (2)", 11],
    ["Sesharao Boddu (1)", 42],
    ["Shallu Arora (3)", 33],
    ["Shankarrao Pabba (2)", 5],
    ["Sharif Ali (1)", 47],
    ["Shashi Ellendula (1)", 21],
    ["Shekar Meela (2)", 53],
    ["Shibaji Ghosh (2)", 45],
    ["Shiva Naidu (3)", 57],
    ["Showri Nandagiri (1)", 37],
    ["Shravan Arra (3)", 26],
    ["Shyam Bavare (3)", 8],
    ["Siva Konduri (2)", 30],
    ["Siva Ponnuru (1)", 41],
    ["Smijo Mathew (3)", 55],
    ["Somaiah Ananthula (2)", 34],
    ["Somaiah Kurre (3)", 63],
    ["Sonali Mehta (2)", 54],
    ["Sreedevi Jallepalli (4)", 38],
    ["Sreedhar Aaloori (2)", 59],
    ["Sreedhar Kanchanakuntla (4)", 45],
    ["Sreeni Kaparthi (1)", 8],
    ["Sreenivas Gande (4)", 27],
    ["Sreenivas Chilukuri (3)", 22],
    ["Sreenivas Mallikarjuna (3)", 50],
    ["Sreenivasa Ranga (4)", 43],
    ["Sreenivasu Kanamarlapudi (4)", 32],
    ["Sreeram Medapalli (2)", 35],
    ["Sridhar Korsapati (2)", 42],
    ["Sridhar Patibandla (2)", 9],
    ["Sridhar Srinivasan (2)", 14],
    ["Sridhar Thota (2)", 5],
    ["Srinath Gande (4)", 27],
    ["Srinivas Kodarapu (4)", 53],
    ["Srinivas Mettu (2)", 44],
    ["Srinivasa Dasari (3)", 17],
    ["Srinivasan Ramamirtham (2)", 20],
    ["Sudarshan Vollala (3)", 7],
    ["Sudeep Ramachandran (3)", 24],
    ["Sudhakar. Roy (4)", 35],
    ["Sujith Alahari (1)", 57],
    ["Sunil Paleru (1)", 59],
    ["Sunil Rai (2)", 36],
    ["Suresh Govindu (3)", 18],
    ["Surya Anakala (4)", 65],
    ["Swamy Thallapally (4)", 67],
    ["Swapan Dhairyawan (3)", 37],
    ["Swatantra Jain (2)", 3],
    ["Swathi Muddasani (4)", 64],
    ["Tarush Anand (2)", 44],
    ["Teja Poola (3)", 52],
    ["Thomas Abraham (2)", 40],
    ["Timir Patel (2)", 10],
    ["Tiru kondisetty (2)", 27],
    ["Uma Mantravadi (2)", 18],
    ["Umang Mehta (2)", 3],
    ["Vale Subramaniyam (2)", 37],
    ["Vamshi Chigullapally (2)", 26],
    ["Vanitha Pothuri (1)", 48],
    ["Varadarajeshwar Rao (3)", 62],
    ["Vasdev Bhagia (2)", 37],
    ["Veeru Kankatala (4)", 15],
    ["Venkat Garlapati (2)", 49],
    ["Venkat Iyer (3)", 18],
    ["Venkat Yadha (2)", 19],
    ["Venu Bhagyanagar (1)", 42],
    ["Venugopal Talapallikotturi (4)", 34],
    ["Vijay Devireddy (3)", 29],
    ["Vijay Pallod (1)", 24],
    ["Vijay Ramamurthy (1)", 36],
    ["Vijaya Rapolu (1)", 48],
    ["Vikas Kancherla (1)", 43],
    ["Vikram Sudireddy (1)", 50],
    ["Vinod Shah (2)", 21],
    ["Vipin Kumar (1)", 24],
    ["Viral Amin (2)", 24],
    ["Vivek Chunduri (3)", 50],
    ["Zarir Sethna (2)", 43],
  ] as const,
  0
);

const Reception = () => {
  const [nameSearch, setNameSearch] = React.useState("");

  return (
    <Container className="reception-container" fluid="md">
      <Helmet>
        <title>Reception</title>
      </Helmet>
      <Row>
        <Col className="d-flex flex-column h-100" md={4}>
          <InputGroup className="pb-3">
            <InputGroup.Text>
              <SearchHeart />
            </InputGroup.Text>
            <Form.Control
              onChange={(e) => setNameSearch(e.target.value)}
              placeholder="Search by name"
              value={nameSearch}
            />
          </InputGroup>
          <section className="mb-3 tables">
            <Table bordered hover size="sm" striped>
              <thead>
                <tr>
                  <th>Party (count)</th>
                  <th>Table No.</th>
                </tr>
              </thead>
              <tbody>
                {tables
                  .filter(([party]) =>
                    party.toLowerCase().includes(nameSearch.toLowerCase())
                  )
                  .map(([party, table]) => (
                    <tr key={party}>
                      <td>{party}</td>
                      <td>{table}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </section>
        </Col>
        <Col className="d-flex flex-column align-items-center h-100" md={8}>
          <img className="mh-100 mw-100" src={receptionFloorPlan} />
        </Col>
      </Row>
    </Container>
  );
};

export default Reception;
